import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Card,
  Button,
  Modal,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
  Autocomplete
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import apiRequest from "../../apiRequest";
import { endPoints } from "../../apis";

function Tutorial() {
  const [tutorials, setTutorials] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const roles = [
    {name : "driver"},
    {name : "customer"}
  ];

  const [tutData, setTutData] = useState({
    name_en: "",
    name_fr: "",
    description_en: "",
    description_fr: "",
    image: null,
    link_en: "",
    link_fr: "",
    role : "",
    status: "active",
  });

  const initialState = {
    name_en: '',
    name_fr: '',
    description_en: '',
    description_fr: '',
    image: null,
    link_en: '',
    link_fr: '',
    role : '',
    status: 'active',
  };

  const getToturials = useCallback(
    async (page) => {
      setLoading(true);
      try {
        const params = { page, total: totalItems };
        const headers = {
        //   "x-access-token": accessToken,
        };
        const response = await apiRequest.get(endPoints.GET_TUTERIALS,
          params,
          headers,
        );

        if (response.success) {
          const { items, pagination } = response.data;
          setTutorials(items);
          setTotalPages(pagination.total_pages);
          setCurrentPage(pagination.current_page);
          setTotalItems(pagination.totalItems);
        }
      } catch (error) {
        console.error("Error fetching tutorials:", error);
        setError("Failed to fetch tutorials. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [ totalItems]
  );

  // Fetch category when currentPage changes
  useEffect(() => {
    setAccessToken(localStorage.getItem("access_token"));
    getToturials(currentPage);
  }, [currentPage, getToturials]);

  // Handle modal open/close
  const handleOpenModal = () => {
    setOpenModal(true);
    setTutData(initialState);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setTutData(initialState);
    setIsEditing(false);
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTutData({ ...tutData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
     
      const data = {
        name_en: tutData.name_en,
        name_fr: tutData.name_fr,
        description_en: tutData.description_en,
        description_fr: tutData.description_fr,
        link_en: tutData.link_en,
        link_fr: tutData.link_fr,
        user_type: tutData.role,
        status: tutData.status
      }
     
      const endPoint = isEditing
        ? `${endPoints.UPDATE_TUTORIAL}/${currentId}`
        : `${endPoints.ADD_TUTORIAL}`;
      const requestMethod = isEditing ? apiRequest.put : apiRequest.post;

      // Send the request
      const response = await requestMethod(endPoint, data, {
        headers: {
        //   'Content-Type': 'multipart/form-data',
          'x-access-token': accessToken,
        },
      });

      // Handle the response
      if (response.success) {
        setSuccess(isEditing ? "Tutorial updated successfully." : "Tutorial added successfully.");
        getToturials(currentPage); 
        handleCloseModal(); // Close the modal
      } else {
        setError(response.message || 'Failed to add/update Toturial.');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred while processing your request.');
    } finally {
      setLoading(false);
    }
  };

  // Handle edit servict type
  const handleEdit = (tutorial) => {
    handleOpenModal();
    setIsEditing(true);
    setTutData({
      name_en: tutorial.name_en || "",
      name_fr: tutorial.name_fr || "",
      description_en: tutorial.description_en || "",
      description_fr: tutorial.description_fr || "",
      link_en: tutorial.link_en || "",
      link_fr: tutorial.link_fr || "",
      role : tutorial.user_type || "",
    //   image: tutorial.image || null,
    //   image_preview: tutorial.image ? `${apiRequest.BASE_URL}/${tutorial.image}` : null,
      status: tutorial.status || "active",
    });

    setCurrentId(tutorial.id);
  };

  // Handle delete tutorial
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      // Send the DELETE request to the API
      const response = await apiRequest.delete(
        `${endPoints.DELETE_TUTORIAL}/${id}`,
        {
          headers: {
            'x-access-token': accessToken,
          },
        }
      );

      // Handle the response
      if (response.success) {
        setSuccess("Toturial deleted successfully.");

        // Update the local state to remove the deleted Toturial
        setTutorials((prev) => prev.filter((tutData) => tutData.id !== id));
      } else {
        setError(response.message || "Failed to delete the Toturial.");
      }
    } catch (error) {
      console.error("Error deleting Toturial:", error);
      setError("An error occurred while deleting the Toturial.");
    } finally {
      setLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage); // Update the current page
    }
  };


  const handleStatusToggle = async (id, currentStatus) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const payload = {
        status: newStatus,
      };

      const headers = {
        'Content-Type': 'application/json',
        'x-access-token': accessToken,
      };

      // Send the PUT request to update the Category status
      const response = await apiRequest.put(
        `${endPoints.STATUS_CATEGORY}/${id}`,
        payload,
        { headers }
      );

      // Handle the response
      if (response.success) {
        setSuccess("Service Type status updated successfully.");

        // Update the local state immediately
        setTutorials((prev) =>
          prev.map((tutData) =>
            tutData.id === id ? { ...tutData, status: newStatus } : tutData
          )
        );
      } else {
        setError(response.message || 'Failed to update service type status.');
      }
    } catch (error) {
      console.error('Error updating service type status:', error);
      setError('An error occurred while updating the service type status.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Tutorials
                </MDTypography>
              </MDBox>
              <MDBox pt={1} px={1}>
                <MDBox
                  pt={1}
                  px={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    label="Search"
                    variant="outlined"
                    margin="normal"
                    placeholder="Search by title or description"
                    style={{ width: "300px" }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    style={{
                      whiteSpace: "nowrap",
                      color: "white",
                    }}
                  >
                    Add Tutorial
                  </Button>
                </MDBox>
                <TableContainer component={Paper} style={{ marginTop: "1px" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Video Link</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Role</TableCell>
                        {/* <TableCell style={{ fontWeight: "bold" }}>Photo</TableCell> */}
                        <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
                      </TableRow>
                      {tutorials.map((tutorial) => (
                        <TableRow key={tutorial.id}>
                          <TableCell>{tutorial.name_en + ' / ' + tutorial.name_fr}</TableCell>
                          <TableCell>{tutorial.link_en + ' / ' + tutorial.link_fr}</TableCell>
                          <TableCell>{tutorial.user_type}</TableCell>
                          {/* <TableCell>
                            <img
                              src={`${apiRequest.BASE_URL}/${tutorial.image}`}
                              alt={tutorial.name_en}
                              style={{ width: "100px", height: "auto" }}
                            />
                          </TableCell> */}
                          <TableCell>
                            <Switch
                              checked={tutorial.status === "active"} // Assuming "active" is the active status
                              onChange={() => handleStatusToggle(tutorial.id, tutorial.status)}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell>
                            <Button
                              onClick={() => handleEdit(tutorial)}
                              color="primary"
                              size="small"
                            >
                              Edit
                            </Button>
                            <Button
                              onClick={() => {
                                setCurrentId(tutorial.id); // Set the service type ID to delete
                                setDeleteDialogOpen(true); // Open the confirmation dialog
                              }}
                              color="error"
                              size="small"
                              style={{ marginLeft: "8px" }}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination Controls */}
                <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  <MDTypography mx={2}>
                    Page {currentPage} of {totalPages} {/* Display current page and total pages */}
                  </MDTypography>
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Modal for Adding/Editing Service Type */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <MDBox
          p={3}
          bgcolor="white"
          borderRadius="lg"
          style={{
            width: 900,
            margin: "50px auto",
            outline: "none",
            backgroundColor: "white",
            maxHeight: "80vh", // Limit the height of the modal
            overflowY: "auto", // Enable vertical scrolling
          }}
        >
          <MDTypography variant="h6" mb={2}>
            {isEditing ? "Edit Tutorial" : "Add Tutorial"}
          </MDTypography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Autocomplete
                        options={roles}
                        getOptionLabel={(option) => option?.name || ""} 
                        value={tutData.role ? roles.find(role => role.name === tutData.role) : null}
                        onChange={(event, newValue) => {
                            setTutData({ ...tutData, role: newValue ? newValue.name : null });
                        }}
                        renderInput={(params) => <TextField {...params} label="Select Role" />}
                        required
                    />
                </Grid>

              {/* Title (EN) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Title (EN)"
                  name="name_en"
                  value={tutData.name_en}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>

              {/* Title (FR) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Title (FR)"
                  name="name_fr"
                  value={tutData.name_fr}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>

              {/* Description (EN) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description (EN)"
                  name="description_en"
                  value={tutData.description_en}
                  onChange={handleInputChange}
                  margin="normal"
                  multiline
                  rows={3}
                />
              </Grid>

              {/* Description (FR) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description (FR)"
                  name="description_fr"
                  value={tutData.description_fr}
                  onChange={handleInputChange}
                  margin="normal"
                  multiline
                  rows={3}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Link (EN)"
                  name="link_en"
                  value={tutData.link_en}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>

              {/* Title (FR) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Link (FR)"
                  name="link_fr"
                  value={tutData.link_fr}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>

              {/* <Grid item xs={12} sm={6}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="file"
                    id="file-input"
                    onChange={(e) => handleFileChange(e, 'image')}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="file-input">
                    <Button variant="outlined" component="span" style={{ width: '100%', color: 'gray' }}>
                      Upload Image 
                    </Button>
                  </label>
                  {tutData.image_preview && (
                    <img
                      src={tutData.image_preview}
                      alt="Preview"
                      style={{ width: '100px', height: 'auto', marginLeft: '10px' }}
                    />
                  )}
                </div>
              </Grid> */}

            </Grid>

            <MDBox mt={3} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{
                  whiteSpace: "nowrap",
                  color: "white",
                }}
              >
                {isEditing ? "Update" : "Add"}
              </Button>
            </MDBox>
          </form>
        </MDBox>
      </Modal>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Delete Tutorial</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this tutorial? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDeleteDialogOpen(false); // Close the dialog
              handleDelete(currentId); // Proceed with deletion
            }}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loading Backdrop */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Error/Success Snackbar */}
      <Snackbar
        open={!!error || !!success}
        autoHideDuration={3000}
        onClose={() => {
          setError(null);
          setSuccess(null);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Positioning the Snackbar
      >
        <Alert
          onClose={() => {
            setError(null);
            setSuccess(null);
          }}
          severity={error ? "error" : "success"}
          sx={{ width: '100%' }}
        >
          {error || success}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default Tutorial;